'use client';
import { Box, CssBaseline, Paper, Stack } from '@mui/material';

import React, { PropsWithChildren } from 'react';
import { ITitleI18nConf } from '../page';
import AndroidPageContent from '../page/AndroidPageContent';

function BottomBar({navBar}:{navBar?:React.ReactNode}) {
  return <Paper
    id="bottom-navigation"
    data-testid="Tabbar__navigationContainer__01aryz6s610p4z0skjq69x5prg"
    data-test-comment="底部导航栏容器，包含应用的主要导航选项"
    sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
    elevation={3}>
    {navBar}
  </Paper>;
}
export function TabbarContainer({ children, titleConf, navBar }: {titleConf?:ITitleI18nConf, navBar:React.ReactNode} & PropsWithChildren)  {
  return (
    <Box data-testid="Tabbar__mainContainer__01aryz6s610p4z0skjq69x5prh" data-test-comment="标签栏主容器，包含页面内容和底部导航栏" sx={{
      minHeight: '100vh',
      paddingBottom: '72px' // 为固定在底部的tabbar留出空间
    }}>
      <CssBaseline />
      <AndroidPageContent titleConf={titleConf}>
        {children}
      </AndroidPageContent>
      <BottomBar navBar={navBar} />
    </Box>
  );
}

